import { createSlice,createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import useTransferData from "../hooks/useTransferData";
import {useFilterData} from "../hooks/useFilter90";
import {Africa, Asia, AustraliaOceania, Europe, NorthAmerica, SouthAmerica} from "../contants/CONTINENT";


const url = "https://disease.sh/v3/covid-19/historical/Anguilla,Antigua and Barbuda,Aruba,Bahamas,Barbados,Belize,Bermuda,British Virgin Islands,Canada,Caribbean Netherlands,Cayman Islands,Costa Rica,Cuba,Curaçao,Dominica,Dominican Republic,El Salvador,Greenland,Grenada,Guadeloupe,Guatemala,Haiti,Honduras,Jamaica,Martinique,Mexico,Montserrat,Nicaragua,Panama,Saint Kitts and Nevis,Saint Lucia,Saint Martin,Saint Pierre Miquelon,Saint Vincent and the Grenadines,Sint Maarten,St. Barth,Trinidad and Tobago,Turks and Caicos Islands,USA,Afghanistan,Armenia,Azerbaijan,Bahrain,Bangladesh,Bhutan,Brunei,Cambodia,China,Cyprus,Georgia,Hong Kong,India,Indonesia,Iran,Iraq,Israel,Japan,Jordan,Kazakhstan,Kuwait,Kyrgyzstan,Lao People's Democratic Republic,Lebanon,Macao,Malaysia,Maldives,Mongolia,Myanmar,Nepal,Oman,Pakistan,Palestine,Philippines,Qatar,S. Korea,Saudi Arabia,Singapore,Sri Lanka,Syrian Arab Republic,Taiwan,Tajikistan,Thailand,Timor-Leste,Turkey,UAE,Uzbekistan,Vietnam,Yemen,Argentina\",Bolivia,Brazil,Chile,Colombia,Ecuador,Falkland Islands (Malvinas),French Guiana,Guyana,Paraguay,Peru,Suriname,Uruguay,Venezuela,Albania\",Andorra,Austria,Belarus,Belgium,Bosnia,Bulgaria,Channel Islands,Croatia,Czechia,Denmark,Estonia,Faroe Islands,Finland,France,Germany,Gibraltar,Greece,Holy See (Vatican City State),Hungary,Iceland,Ireland,Isle of Man,Italy,Latvia,Liechtenstein,Lithuania,Luxembourg,Macedonia,Malta,Moldova,Monaco,Montenegro,Netherlands,Norway,Poland,Portugal,Romania,Russia,San Marino,Serbia,Slovakia,Slovenia,Spain,Sweden,Switzerland,UK,Ukraine,Australia,Cook Islands,Fiji,French Polynesia,Kiribati,Marshall Islands,Micronesia,New Caledonia,New Zealand,Niue,Palau,Papua New Guinea,Samoa,Solomon Islands,Tonga,Vanuatu,Wallis and Futuna,Algeria\",Angola,Benin,Botswana,Burkina Faso,Burundi,Cabo Verde,Cameroon,Central African Republic,Chad,Comoros,Congo,Côte d'Ivoire,DRC,Djibouti,Egypt,Equatorial Guinea,Eritrea,Ethiopia,Gabon,Gambia,Ghana,Guinea,Guinea-Bissau,Kenya,Lesotho,Liberia,Libyan Arab Jamahiriya,Madagascar,Malawi,Mali,Mauritania,Mauritius,Mayotte,Morocco,Mozambique,Namibia,Niger,Nigeria,Rwanda,Réunion,Saint Helena,Sao Tome and Principe,Senegal,Seychelles,Sierra Leone,Somalia,South Africa,South Sudan,Sudan,Swaziland,Tanzania,Togo,Tunisia,Uganda,Western Sahara,Zambia,Zimbabwe,?lastdays=93"

export const fetchCovid90= createAsyncThunk(
    "covid90/fetchCovid90",
    async () => {
        const response = await axios.get(url);
        const forCovid90ays =  useTransferData(response.data)
        const {top:topAsia,low:lowAsia} = useFilterData(Object.values(forCovid90ays)[0],Asia)
        const {top:topEurope,low:lowEurope} = useFilterData(Object.values(forCovid90ays)[0],Europe)
        const {top:topNorthAmerica,low:lowNorthAmerica} = useFilterData(Object.values(forCovid90ays)[0],NorthAmerica)
        const {top:topSouthAmerica,low:lowSouthAmerica} = useFilterData(Object.values(forCovid90ays)[0],SouthAmerica)
        const {top:topAustraliaOceania,low:lowAustraliaOceania} = useFilterData(Object.values(forCovid90ays)[0],AustraliaOceania)
        const {top:topAfrica,low:lowAfrica} = useFilterData(Object.values(forCovid90ays)[0],Africa)

        const figureData = [
            {Continent: "Asia", Stat:  [{rank: "Top",data : topAsia} ,{rank: "Low", data: lowAsia}] },
            {Continent: "Africa", Stat:  [{rank: "Top",data : topAfrica} ,{rank: "Low", data: lowAfrica}]},
            {Continent: "Europe", Stat:  [{rank: "Top",data : topEurope} ,{rank: "Low", data: lowEurope}]},
            {Continent: "AustraliaOceania", Stat:  [{rank: "Top",data : topAustraliaOceania} ,{rank: "Low", data: lowAustraliaOceania}]},
            {Continent: "NorthAmerica", Stat:  [{rank: "Top",data : topNorthAmerica} ,{rank: "Low", data: lowNorthAmerica}]},
            {Continent: "SouthAmerica", Stat:  [{rank: "Top",data : topSouthAmerica} ,{rank: "Low", data: lowSouthAmerica}]}]

        return figureData;

    }
    );

export const initialState = {
    covid90:[],
}


const Covid90Slice = createSlice({
        name: 'covid90',
        initialState,
        reducers: {

        },
        extraReducers: {
            [fetchCovid90.pending]: () => {
                console.log("Pending");
            },
            [fetchCovid90.fulfilled]: (state, {payload}) => {
                console.log("Fetched Successfully!");
                return {...state, covid90: payload}
            },
            [fetchCovid90.rejected]: () => {
                console.log("Rejected!");
            },

        }
    }

)

// export const {
// } = Covid90Slice.actions

export const Covid90Selector = state => state.covid90.covid90
export default Covid90Slice.reducer
